import { Form } from "react-router-dom"
import { useActionData, useNavigation, Link } from 'react-router-dom';
import AdminImagesForm from '../../components/admin/AdminImagesForm.jsx'
import AdminImagesShow from '../../components/admin/AdminImagesShow.jsx'
import { CreateImage } from '../../repo/ImagesRepo.js'

export default function ImageNewPage() {
  const response = useActionData()
  const createNavigation = useNavigation()
  const isSubmitting = createNavigation.state === 'submitting'

  return (
    <section className="m-8">
      {response && response.status && response.status  ? (
        <AdminImagesShow image={response.data} status="created"/>
      ) : (
        <>
          <h1>Create New Image</h1>
          <div id="image-create-form" className={`w-full py-4 mb-4'`}>
            <Form className="space-y-4 md:space-y-6 mt-4">
              <AdminImagesForm errors={(response && response.errors) ? response.errors : null } isSubmitting={isSubmitting}/>
            </Form>
          </div>

          <div id="images" className={`w-full pt-4 mt-4'`}>
            <Link className="hover:no-underline underline" to="/cocofantoelefanto/images">Back to Images</Link>
          </div>
        </>
      )}
    </section>
  )
}

export async function action({request}) {
  const data = await request.formData()

  return CreateImage(data.get('image'))
}
